import axios, { AxiosInstance } from 'axios';

type HttpMethod = 'GET' | 'POST' | 'PUT' | 'DELETE' | 'PATCH';

interface RequestOptions {
  method: HttpMethod;
  headers: Record<string, string>;
  body?: string | FormData | null;
  credentials: RequestCredentials;
}

function setOptionsClient(method: HttpMethod = 'GET', body: unknown = null): RequestOptions {
  const token = localStorage.getItem('token');

  const headers: Record<string, string> = {
    'Content-Type': 'application/json',
    Accept: 'application/json',
    'X-Requested-With': 'XMLHttpRequest',
    Authorization: 'Bearer ' + token,
  };

  return {
    method,
    headers,
    body: body ? JSON.stringify(body) : null,
    credentials: 'include',
  };
}

function setOptionsClientFormData(method: HttpMethod = 'POST', body: FormData): RequestOptions {
  const token = localStorage.getItem('token');

  const headers: Record<string, string> = {
    'X-Requested-With': 'XMLHttpRequest',
    Authorization: 'Bearer ' + token,
  };

  return {
    method,
    headers,
    body,
    credentials: 'include',
  };
}

export async function doApi<T>(
  path: string,
  method: HttpMethod = 'GET',
  body: unknown = null,
  withFile: boolean = false
): Promise<T> {
  try {
    const options = withFile
      ? setOptionsClientFormData(method, body as FormData)
      : setOptionsClient(method, body);

    const response = await fetch(process.env.REACT_APP_BACKEND_URL + path, options);
    const responseData: T = await response.json();
    return responseData;
  } catch (error) {
    console.error('Error during request:', error);
    throw error;
  }
}

export const apiClient: AxiosInstance = axios.create({
  baseURL: process.env.REACT_APP_BACKEND_URL,
  headers: {
    'X-Requested-With': 'XMLHttpRequest',
  },
  withCredentials: true,
});
